<template>
  <div :class="['productList', { inApp: $root.$data.isApp || isMiniProgram }]" id="yd-page5">
    <common-title titleName="课程列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="content">
      <ul class="courseList" v-if="courseList.length">
        <li v-for="(item, keys) in courseList" :key="keys">
          <CombinationCard v-if="item.setType === 1" :item="item" :index="keys" />
          <HotCourseCard v-else :item="item" :key="keys" />
        </li>
      </ul>
      <Loading ref="load" v-if="!courseList.length" />
      <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
    </div>
  </div>
</template>

<script>
import { reqProducts } from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import { resetProductData, resetCoursePackage, whatEev } from '@/utils/tools';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import HotCourseCard from '../../components/hotCourseCard/hotCourseCard.vue';
import Loading from '../../components/loading/loading.vue';

export default {
  components: {
    CommonTitle,
    HotCourseCard,
    EmptyData,
    Loading,
    CombinationCard,
  },
  data() {
    return {
      courseList: [], // 课程列表
      loading: false,
      refreshing: false,
      listEmpty: false, // 在loading时不显示缺省页
      isMiniProgram: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.$refs.load.show = true;
    });
    this.getCourse();
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
    }
    document.title = '课程列表';
  },
  mounted() {},
  methods: {
    // 请求产品列表
    async getCourse() {
      const { productId, hastPackage } = this.$route.query;
      console.log(typeof productId, productId);
      if (Number(hastPackage) === 1) {
        this.packageAndProduct(productId);
      } else {
        this.onlyProduct(productId);
      }
    },
    async onlyProduct(productId) {
      const res = await reqProducts(productId.split(','), 4);
      if (res.code === 0 && res.data) {
        if (this.refreshing) {
          this.courseList = [];
        } else {
          // 初始请求是全局loading不显示，下拉时不需要加载全局loading
          this.$refs.load.show = false;
        }
        this.refreshing = false;
        this.loading = false;
        this.courseList = resetProductData(res.data || []);
        this.totalPages = res.data.length;
        if (!res.data.length) {
          this.listEmpty = true;
        }
      } else {
        this.$refs.load.show = false;
        this.listEmpty = true;
        this.refreshing = false;
      }
    },
    packageAndProduct(productIds) {
      const recommendList = productIds.split(',').map((item) => {
        const [productId,productType] = item.split('-');
        return {
          productType,
          productId,
        };
      });
      console.log(recommendList);
      // const recommendList = JSON.parse(productId);
      // console.log(recommendList);
      const allProductIds = [];
      const allPackageIds = [];
      recommendList.forEach((item) => {
        if (Number(item.productType) === 0) {
          allProductIds.push(item.productId);
        } else {
          allPackageIds.push(item.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};
      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || []);
        const resPackage = resetCoursePackage(res1?.data || []);
        const courseList = [];
        recommendList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = Number(child.productType) === 0 ? course.productId : course.packageId;
            return String(id) === child.productId.toString();
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && courseList.push(findRes);
        });
        console.log(courseList);
        this.courseList = courseList;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.productList {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 100px 36px 130px;
  background: #fefeff;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .content {
    height: 100%;
  }
  .courseList {
    box-sizing: border-box;
    width: 100%;
    min-height: 98px;
    padding: 20px 0;
    background: #fff;
  }

  .courseList > li {
    position: relative;
    width: 686px;
    // height: 3.06px;
    // border: 1px solid red;
    // display: flex;
    // flex-wrap: nowrap;
    margin: 0 auto;
    // margin-bottom: 25px;
    // padding: 0.32px;
    // background: rgba(255, 255, 255, 1);
    // border-radius: 16px;
    // box-shadow: 0 4px 24px rgba(240, 244, 244, 1);
    // opacity: 1;
    .liveImg {
      position: absolute;
      top: 0;
      right: 0;
      width: 140px;
      height: 50px;
      border-radius: 0 16px 0 32px;
    }
  }
}
</style>
